import { render, staticRenderFns } from "./AddDocumentsEdit.vue?vue&type=template&id=5704d17a&scoped=true&"
import script from "./AddDocumentsEdit.vue?vue&type=script&lang=js&"
export * from "./AddDocumentsEdit.vue?vue&type=script&lang=js&"
import style0 from "./AddDocumentsEdit.vue?vue&type=style&index=0&id=5704d17a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5704d17a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VDialog,VRadio,VRadioGroup,VRow})
